import { tns } from 'tiny-slider/src/tiny-slider';

const branchesSlider = document.querySelector('.js-branch-slider');
const servicesSlider = document.querySelector('.js-service-slider');
const prevBtnElBranch = document.querySelector('.js-branch-slider__btn--prev');
const nextBtnElBranch = document.querySelector('.js-branch-slider__btn--next');
const prevBtnElService = document.querySelector('.js-service-slider__btn--prev');
const nextBtnElService = document.querySelector('.js-service-slider__btn--next');

if (branchesSlider) {
  // eslint-disable-next-line no-unused-vars
  const slider = tns({
    container: branchesSlider,
    prevButton: prevBtnElBranch,
    nextButton: nextBtnElBranch,
    mode: 'carousel',
    items: 1,
    gutter: 24,
    loop: false,
    slideBy: '1',
    autoplay: false,
    controlsContainer: '#carouselBranchesControls',
    nav: false,
    touch: true,
    mouseDrag: false,
    responsive: {
      826: {
        items: 2,
      },
      1246: {
        items: 3,
      },
      1570: {
        items: 4,
      },
    },
  });
}

const productDetailImageSlider = document.querySelector('.product-detail-image-slider');

if (productDetailImageSlider) {
  tns({
    container: productDetailImageSlider,
    mode: 'carousel',
    items: 1,
    gutter: 24,
    loop: false,
    slideBy: '1',
    autoplay: false,
    nav: true,
    touch: true,
    mouseDrag: true,
    responsive: {
      826: {
        items: 2,
      },
    },
  });
}

const homepageImageSliders = document.querySelectorAll('.homepage-image-slider');

if(homepageImageSliders)
{
  [...homepageImageSliders].forEach((item) =>
  {
    tns({
      container: item,
      mode: 'carousel',
      items: 1,
      gutter: 24,
      loop: true,
      slideBy: '1',
      autoplay: true,
      nav: true,
      touch: true,
      mouseDrag: true,
    });
  });
}

if (servicesSlider) {
  // eslint-disable-next-line no-unused-vars
  const slider = tns({
    container: servicesSlider,
    prevButton: prevBtnElService,
    nextButton: nextBtnElService,
    mode: 'carousel',
    items: 2,
    gutter: 16,
    loop: false,
    slideBy: '1',
    autoplay: false,
    controlsContainer: '#carouselServicesControls',
    nav: false,
    touch: true,
    mouseDrag: false,
    edgePadding: 16,
    fixedWidth: 216,
    responsive: {
      576: {
        items: 2,
        edgePadding: 0,
        fixedWidth: 0,
      },
      826: {
        items: 3,
      },
      1068: {
        items: 4,
      },
      1246: {
        items: 5,
      },
      1570: {
        items: 6,
      },
    },
  });
}
